export default "__VITE_ASSET__BkErmkQH__"